import React from "react";
import styled from "@emotion/styled";
import { Avatar, Box, Button, Typography, Link } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SignInComponent from "@/components/auth/SignIn";
import useAuth from '@/hooks/useAuth';
import { useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import LogoComponent from "@/components/logos/Logo";

const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function SignIn() {
  const { signIn, signInWithGoogle, user, isAuthenticated, signUp } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [user, navigate]);

  const loginWithGoogle = async () => {
    try {
      await signInWithGoogle();
      // Redirect handled by useEffect
    } catch (error) {
      setError("Google sign-in failed");
      console.error(error);
    }
  };

  const loginWithEmail = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      await signIn(email, password);
      // Redirect handled by useEffect
    } catch (error) {
      setError("Email or password incorrect");
      console.error(error);
    }
  };

  return (
    <React.Fragment>
      <div style={{textAlign: 'center', marginBottom: '20px'}}>
        <LogoComponent fill="#0f4c81" style={{width: "100px", margin: "0px auto"}} />
        <br />
        <br />
        <Typography component="h1" variant="h3" align="center" gutterBottom>
          Log in to your account
        </Typography>
        <Box display="grid" gridTemplateColumns="1fr auto 1fr" gap={2} alignItems="center">
            <Box>
              <Typography component="h2" variant="subtitle1" align="center">
                Welcome back! <br /> 
                Please enter your details.
              </Typography>
              <br />
              <form onSubmit={loginWithEmail} style={{ maxWidth: 320, margin: '0 auto' }}>
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  style={{ width: '100%', padding: 8, marginBottom: 12, borderRadius: 4, border: '1px solid #ccc' }}
                  required
                />
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  style={{ width: '100%', padding: 8, marginBottom: 12, borderRadius: 4, border: '1px solid #ccc' }}
                  required
                />
                <Button type="submit" variant="contained" color="primary" fullWidth style={{ marginBottom: 16 }}>
                  Sign in with Email
                </Button>
              </form>
              <Link href="mailto:support@mitty.app">Request an Invitation</Link>
            </Box>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%">
              <div style={{
                width: '60px', 
              }}></div>
              <Typography variant="subtitle2" color="textSecondary" style={{ 
                margin: '8px 0',
                position: "absolute",
                zIndex: 1, 
                borderRadius: '50%',
                backgroundColor: '#fff',
                height: '30px',
                width: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #ccc',
              }}>or</Typography>
              <div style={{
                border: '1px solid #ccc', 
                width: '1px', 
                borderRight: 'none',
                height: '180px',
                margin: '12px 0',
                position: 'absolute'
              }}></div>
            </Box>
            <Box>
              <Button variant="contained" onClick={loginWithGoogle} fullWidth>
                Sign In with Google
              </Button>
            </Box>
          </Box>
        {error && <Typography color="error" style={{ marginTop: 16 }}>{error}</Typography>}
      </div>
      
    </React.Fragment>
  );
}

export default SignIn;
